<template>
<div>
	<div class="row">
		<div class="col-md-6">
			<div class="panel">
				<div class="panel-heading">
					<h4>Nuevo Proveedor</h4>
				</div>
				<div class="panel-body">
					<div class="row">
						<div class="col-md-6">
							<div class="form-group" :class="{ 'has-error' : errors.has('Name') }">
								<label class="control-label">Nombre *</label>
								<input v-validate="'required'" v-model="data.name" name="Name" type="text" class="form-control">
								<small v-show="errors.has('Name')" class="form-text text-danger">
									{{ errors.first('Name') }}
								</small>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Persona de contacto</label>
								<input v-model="data.contact_person" type="text" class="form-control">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Número de identificación (NIF/CIF)</label>
								<input v-model="data.identification_number" type="text" class="form-control">
							</div>
						</div>
					</div>
					<div class="row">
						<div v-if="statuses" class="col-md-3">
							<div v-if="statuses.length" class="form-group">
								<label>Estado</label>
								<select v-model="data.provider_status_id" class="form-control">
									<option v-for="status in statuses" :value="status.id">
										<span v-if="status.lang">
											{{ status.lang.name }}
										</span>
										<span v-else>
											{{ status.name }}
										</span>
									</option>
								</select>
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>E-mail</label>
								<input v-model="data.email" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>E-mail 2</label>
								<input v-model="data.email_2" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Fax</label>
								<input v-model="data.fax" type="text" class="form-control">
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label>Teléfono</label>
								<input v-model="data.phone" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Teléfono 2</label>
								<input v-model="data.phone_2" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Móvil</label>
								<input v-model="data.mobile" type="text" class="form-control">
							</div>
						</div>
						<div class="col-md-3">
							<div class="form-group">
								<label>Móvil 2</label>
								<input v-model="data.mobile_2" type="text" class="form-control">
							</div>
						</div>
					</div>
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button
							class="ladda-button btn btn-success"
							ref="btnStore"
							data-style="expand-right"
							data-size="s"
							@click="validate"> 
								<span class="ladda-label">Guardar</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="col-md-6">
			<div class="panel">
				<div class="panel-heading">
					<h4>Ubicación</h4>
				</div>
				<div class="panel-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>Buscar</label>
								<input ref="inputAutocompleteCreate" type="search" id="input-autocomplete-create" class="form-control" placeholder="Buscar...">
							</div>
						</div>
					</div>
					<div v-if="data.place" class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>País</label>
								<input v-model="data.place.country" type="text" class="form-control" placeholder="País...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Comunidad autónoma</label>
								<input v-model="data.place.administrative_area_level_1" type="text" class="form-control" placeholder="Comunidad autónoma...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Provincia</label>
								<input v-model="data.place.administrative_area_level_2" type="text" class="form-control" placeholder="Provincia...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Ciudad</label>
								<input v-model="data.place.locality" type="text" class="form-control" placeholder="Ciudad...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('Address') }">
								<label class="control-label">Dirección *</label>
								<input v-validate="'required'" name="Address" v-model="data.place.formatted_address" type="text" class="form-control" placeholder="Dirección...">
								<small v-show="errors.has('Address')" class="form-text text-danger">
									{{ errors.first('Address') }}
								</small>
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Número</label>
								<input v-model="data.place.street_number" type="text" class="form-control" placeholder="Número...">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Barrio</label>
								<input v-model="data.place.sublocality_level_1" type="text" class="form-control" placeholder="Barrio...">
							</div>
						</div>
						<div class="col-md-12">
							<div class="form-group">
								<label>Código postal</label>
								<input v-model="data.place.postal_code" type="text" class="form-control" placeholder="Código postal...">
							</div>
						</div>

						<div class="col-md-6">
							<div class="form-group">
								<label>Latitud</label>
								<input v-model="data.place.lat" type="text" class="form-control" placeholder="Latitud...">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Longitud</label>
								<input v-model="data.place.lng" type="text" class="form-control" placeholder="Longitud...">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				statuses: null,

				data: {
					name: null,
					email: null,
					email_2: null,
					mobile: null,
					mobile_2: null,
					phone: null,
					phone_2: null,
					fax: null,
					contact_person: null,
					identification_number: null,
					provider_status_id: 1,
					place: {
						formatted_address: null,
						name: null,
						google_place_id: null,
						url: null,
						country: null,
						country_short_name: null,
						postal_code: null,
						administrative_area_level_1: null,
						administrative_area_level_2: null,
						locality: null,
						route: null,
						street_number: null,
						sublocality_level_1: null,
						sublocality_level_2: null,
						lat: null,
						lng: null,
					}
				},

				autocomplete: null,
			}
		},
		mounted () {
			this.init()
			this.getStatus()
		},
		methods: {
			init() {
				this.initAutocomplete()
			},
			getStatus() {
				this.$http.get('admin/management/providers/statuses')
				.then(response => {
					this.statuses = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store() {
				var loading = Ladda.create(this.$refs.btnStore);
				loading.start();
				this.$http.post('admin/management/providers', this.data)
				.then(response => {
					var data = response.body.data
					this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + "/admin/management/providers/" + data.id + '/edit')
					loading.stop()
					swal({ 
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					loading.stop();
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
			initAutocomplete() {
				var that = this
				this.autocomplete = new google.maps.places.Autocomplete(
					(that.$refs.inputAutocompleteCreate),
					{types: ['geocode']}
				)

				this.autocomplete.addListener('place_changed', function(event) {
					var place = that.autocomplete.getPlace();
					if(place) {
						that.loadPlace(place)
					}
				})
			},
			clearData() {
				for(var value in this.data.place) {
					this.data.place[value] = null
				}
			},
			loadPlace(place) {
				this.clearData()
				var that = this
				this.data.place.formatted_address = place.formatted_address
				this.data.place.name = place.name
				this.data.place.google_place_id = place.place_id
				this.data.place.url = place.url

				this.data.place.lat = place.geometry.location.lat()
				this.data.place.lng = place.geometry.location.lng()

				var address_components = []
				if(place.address_components) {
					place.address_components.forEach(function(element) {
						var type = element.types[0]
						var component = {
							type: type,
							value: element.long_name
						}
						address_components.push(component)
						if(type == 'country') {
							var component = {
								type: 'country_short_name',
								value: element.short_name
							}
							address_components.push(component)
						}
					})
				}
				address_components.forEach(function(element) {
					if(that.data.place[element.type] !== 'undefined') {
						that.data.place[element.type] = element.value
					}
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/providers/views/Create.vue